// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1cfpk","title":"FrontImage_title__3QsM0"};